/* eslint-disable @typescript-eslint/no-explicit-any */
import { globals } from "@/main";
import { requestHeaders } from "../requests/header.request";
import { api } from "@/dto/api.endpoint.dto";
import {
  apiErrorResponse,
  apiSuccessResponse,
} from "@/services/requests/response.request";

export const getMediaFolderService = async (params: string): Promise<any> => {
  const headers = await requestHeaders();

  return await globals.$axios
    .get(api.folderMedia + params, {
      headers,
    })
    .then((response: any) => {
      return apiSuccessResponse(response);
    })
    .catch((error: any) => {
      return apiErrorResponse(error);
    });
};

export const listMediaService = async (params: string): Promise<any> => {
  const headers = await requestHeaders();

  return await globals.$axios
    .get(api.listMedia + params, {
      headers,
    })
    .then((response: any) => {
      return apiSuccessResponse(response);
    })
    .catch((error: any) => {
      return apiErrorResponse(error);
    });
};

export const detailMediaService = async (params: string): Promise<any> => {
  const headers = await requestHeaders();

  return await globals.$axios
    .get(api.detailMedia + params, {
      headers,
    })
    .then((response: any) => {
      return apiSuccessResponse(response);
    })
    .catch((error: any) => {
      return apiErrorResponse(error);
    });
};
